import { render, staticRenderFns } from "./CustomContent.vue?vue&type=template&id=9c7ec448&"
import script from "./CustomContent.vue?vue&type=script&lang=js&"
export * from "./CustomContent.vue?vue&type=script&lang=js&"
import style0 from "./CustomContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports